<div class="main-modal">
  <div class="modal-header">
    <h4 class="modal-title-text">
      Requested {{ requestedType }}
    </h4>
    <div class="header-actions">
      <i
        class="fa fa-times hoverable"
        role="button"
        tabindex="0"
        (click)="close()"
        (keyup.enter)="close()"
        aria-label="Close"
      ></i>
    </div>
  </div>

  <div class="modal-body dashboard-container" [ngClass]="currentTheme">
    @if (listLoading) {
<div class="text-center loading-block">
      <i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
    </div>
}

    @if (!listLoading && loadError) {
<div class="error-block">
      {{ loadError }}
    </div>
}

    @if (!listLoading && !loadError) {
<div class="vbes-layout">
      <div class="vbes-toolbar-row" role="search">
        <div class="vbes-search-group">
          <div class="vbes-search-group__field">
            <input
              id="vbes-search"
              type="search"
              class="vbes-search-group__input"
              autocomplete="off"
              [value]="searchTerm"
              (input)="onSearchChange($any($event.target).value)"
              placeholder="Filter table..."
              aria-label="Filter selection table"
            />
            <i class="fa fa-search vbes-search-group__icon" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <div class="vbes-table-region">
        @if (filteredRows.length > 0) {
<div class="table-responsive">
          <table class="table table-bordered selection-table custom-table">
            <thead>
              <tr>
                @for (col of columns; track $index) {
<th
                 
                  scope="col"
                  class="sortable-header"
                  [ngStyle]="col.widthPx ? { minWidth: col.widthPx + 'px' } : {}"
                  (click)="onColumnSort(col)"
                  (keyup.enter)="onColumnSort(col)"
                  tabindex="0"
                  [attr.aria-sort]="
                    sortField === col.field ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'
                  "
                >
                  <span class="th-inner">
                    <span class="th-label">{{ col.header }}</span>
                    <i [ngClass]="sortIconClasses(col)" aria-hidden="true"></i>
                  </span>
                </th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of filteredRows; track trackByIndex(i); let i = $index) {
<tr
               
                [class.row-emphasis]="isRowHighlighted(row)"
                [class.row-stripe]="i % 2 === 1"
              >
                @for (col of columns; track $index) {
<td>{{ cellValue(row, col) }}</td>
}
              </tr>
}
            </tbody>
          </table>
        </div>
} @else {

          <p class="empty-message">{{ emptyMessage() }}</p>
        
}
        
      </div>
    </div>
}
  </div>
</div>
